import { render, staticRenderFns } from "./seniorDismissalStatusHistoryDetail.vue?vue&type=template&id=783fc58a"
import script from "./seniorDismissalStatusHistoryDetail.vue?vue&type=script&lang=js"
export * from "./seniorDismissalStatusHistoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('783fc58a')) {
      api.createRecord('783fc58a', component.options)
    } else {
      api.reload('783fc58a', component.options)
    }
    module.hot.accept("./seniorDismissalStatusHistoryDetail.vue?vue&type=template&id=783fc58a", function () {
      api.rerender('783fc58a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/com/seniorDismissalStatusHistoryDetail.vue"
export default component.exports